import * as _events2 from "@walletconnect/events";
var _events = "default" in _events2 ? _events2.default : _events2;
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IHeartBeat = void 0;
const events_1 = _events;
class IHeartBeat extends events_1.IEvents {
  constructor(opts) {
    super();
  }
}
exports.IHeartBeat = IHeartBeat;
//# sourceMappingURL=heartbeat.js.map
export default exports;